// extracted by mini-css-extract-plugin
export var catIcon = "RecipeIcon-module--catIcon--86+S7";
export var iconWrapper = "RecipeIcon-module--iconWrapper--KMr8c";
export var imageWrapper = "RecipeIcon-module--imageWrapper--aQJMo";